(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-sticky-wrapper"] && !Shopify.designMode) return;
  try {
    /**
   * Product Sticky Wrapper
   * Shows a sticky product bar when user scrolls past the product form
   */
  document.addEventListener('DOMContentLoaded', function () {
    // Cache DOM elements
    const productForm = document.querySelector('.product-form');
    const stickyWrapper = document.querySelector('.product-sticky-wrapper');
    const stickyButton = document.querySelector('.product-sticky__button');
    
    // Scroll direction tracking
    let lastScrollY = window.scrollY;
    let isScrollingDown = false;

    // Initialize sticky wrapper visibility based on scroll
    if (productForm && stickyWrapper) {
      // Track scroll direction for better UX
      window.addEventListener('scroll', () => {
        const currentScrollY = window.scrollY;
        isScrollingDown = currentScrollY > lastScrollY;
        lastScrollY = currentScrollY;
      }, { passive: true });

      // Intersection Observer to detect when product form leaves viewport
      const observerOptions = {
        threshold: 0.1, // Trigger when 10% of element is visible/invisible
        rootMargin: '0px',
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          // Show sticky wrapper when scrolling DOWN and product-form exits viewport
          if (!entry.isIntersecting && isScrollingDown) {
            stickyWrapper.classList.add('product-sticky-wrapper-visible');
          }
          // Hide sticky wrapper when product-form enters viewport (any direction)
          else if (entry.isIntersecting) {
            stickyWrapper.classList.remove('product-sticky-wrapper-visible');
          }
        });
      }, observerOptions);

      observer.observe(productForm);
    }

    // Handle sticky button click to scroll back to product info
    if (stickyButton) {
      stickyButton.addEventListener('click', function () {
        // Try multiple selectors to find the product info container (fallback chain)
        const productInfoContainer = 
          document.querySelector('[id^="ProductInfo-"]') || 
          document.querySelector('.product__info-container') ||
          productForm ||
          document.querySelector('.sidebar__inner-padding');
        
        if (productInfoContainer) {
          productInfoContainer.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        }
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
